import React from 'react'

const Footer = () => {
    return (
        <div>
            <footer>
                <p>Linnea Frisk @Technigo Bootcamp 2022</p>
            </footer>
        </div>
    )
}

export default Footer